import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const Wrapper = styled.div`
  margin: 0 auto 15px auto;
  min-height: calc(100vh);
  height: 100%;
  display: flex;
  flex-direction: column;
  
  @media (min-width: ${breakpoints.desktop}) {
  .react-tabs__tab-list { 
      width: 450px;
      position: absolute;
      right: 0px;
      top: 70px;
      border-bottom: 0;
      display: none;
    }
    
    .react-tabs__tab {
      font-size: 1.4rem;
    }
  }
`;
